/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useRef, InputHTMLAttributes } from 'react';
import { useField } from '@unform/core';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  fontSizeText?: string;
  lineHeight?: string;
  className?: string;
  options: {
    id: string;
    value: string;
    option: string;
  }[];
}
export default function RadioInput({
  name,
  fontSizeText = '',
  lineHeight = '',
  className = 'text-uppercase',
  options,
  ...rest
}: Props) {
  const inputRefs = useRef<HTMLInputElement[]>([]);
  const { fieldName, registerField, defaultValue = '' } = useField(name);
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs.current,
      getValue: (refs: HTMLInputElement[]) => {
        return refs.find(ref => ref.checked)?.value || '';
      },
      setValue: (refs: HTMLInputElement[], id: string) => {
        const inputRef = refs.find(ref => ref.id === id);
        if (inputRef) inputRef.checked = true;
      },
      clearValue: (refs: HTMLInputElement[]) => {
        const inputRef = refs.find(ref => ref.checked === true);
        if (inputRef) inputRef.checked = false;
      },
    });
  }, [defaultValue, fieldName, registerField]);

  return (
    <div
      style={{
        fontSize: `${fontSizeText}`,
        lineHeight: `${lineHeight}`,
      }}
    >
      {options.map(option => (
        <label
          htmlFor={option.id}
          key={option.id}
          className={`my-0 ${className}`}
        >
          <input
            ref={ref => inputRefs.current.push(ref as HTMLInputElement)}
            id={option.id}
            type="radio"
            name={name}
            className="mr-2"
            defaultChecked={defaultValue.includes(option.id)}
            value={option.value}
            {...rest}
          />
          {option.option}
        </label>
      ))}
    </div>
  );
}
